function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * List of helper methods related to the Sitecore rendering
 */
var WDHSitecoreHelper = /*#__PURE__*/function () {
  function WDHSitecoreHelper() {
    _classCallCheck(this, WDHSitecoreHelper);
  }
  return _createClass(WDHSitecoreHelper, null, [{
    key: "fixRTESpanLinks",
    value:
    /**
     * Changes any <span class="some-class"><a /></span> to <span><a class="some-class" /></span>
     * @param Strig[] classList List of classes to fix
     */
    function fixRTESpanLinks(classList) {
      classList.forEach(function (className) {
        var aList = document.querySelectorAll("span.".concat(className, ">a"));
        aList.forEach(function (aTag) {
          var spanTag = aTag.parentNode;
          WDHSitecoreHelper.switchClass(className, spanTag, aTag);
        });
        var spanList = document.querySelectorAll("a>span.".concat(className));
        spanList.forEach(function (spanTag) {
          var aTag = spanTag.parentNode;
          WDHSitecoreHelper.switchClass(className, spanTag, aTag);
        });
      });
    }

    /**
     * Removes className from one element and adds it to another
     * @param className
     * @param elementToRemoveFrom
     * @param elementToAddTo
     * @private
     */
  }, {
    key: "switchClass",
    value: function switchClass(className, elementToRemoveFrom, elementToAddTo) {
      elementToRemoveFrom.classList.remove(className);
      elementToAddTo.classList.add(className);
    }
  }]);
}();
export default WDHSitecoreHelper;